var _defs, _defs2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "map-background",
    x: 0,
    y: 0,
    width: 10,
    height: 10,
    patternUnits: "userSpaceOnUse",
    patternContentUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "pattern-circle",
    cx: 5,
    cy: 5,
    r: 4
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "map-background-hovered",
    x: 0,
    y: 0,
    width: 10,
    height: 10,
    patternUnits: "userSpaceOnUse",
    patternContentUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "pattern-circle-hovered",
    cx: 5,
    cy: 5,
    r: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapBackground);
export default __webpack_public_path__ + "static/media/map-background.4caeea8f.svg";
export { ForwardRef as ReactComponent };